
<div
  style="padding-left:14%;padding-right:14%;padding-top: 3%;line-height: 25px;font-size: 19px"
>
  <div class="row">
    <img src="./assets/img/doktorslogo.png" class="header-img"  />
    <h3 style="float: right;margin-top: 20px" align="center">
      Privacy Statement
    </h3>
  </div>
  <hr />

  <p style="margin-top: 60px"></p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>What do we do with your information?</b>
  </div>

  <p>
    When you make any appointment using our app, we share personal information
    like your name, age, phone number,Profile Image and city to the doctor with whom you make
    appointment with, medical information in shared only after your consent.
  </p>
  <p>
    We ask you to select your city in that we can filter doctors and diagnostic
    centers and hospitals from your selected city.
  </p>
  <p>
    If you want you can keep your prescription and save your medical conditions
    like diabetic or not allergic to something or not etc. So that doctor
    attending you can be aware about your medical condition while attending you.
  </p>
  <p>
    We keep your reports from Diagnostic centers on your consent so that you
    have the convenience to receive your report on your mobile phone, with
    security. No one else can access your report accept you (User).
  </p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 2 - CONSENT</b>
  </div>
  <p>
    When you provide us with personal information to complete a transaction,
    verify your payment information.
  </p>
  <p>
    If we ask you for any personal information for a secondary reason like
    marketing, we will either ask you directly for your expressed consent or
    provide you with an opportunity to say no.
  </p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>How do I draw my consent?</b>
  </div>
  <p>
    If after your opt-in, you change your mind, you may withdraw your consent
    for us to contact you, for continued collection, us or disclosure of your
    information, at any time, by containing us at info@mavinglobus.com or
    mailing us at City center market, Haridwar Road opposite Nulife clinic,
    Najibabad, Pin-246763(UP).
  </p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 3 - Disclosure </b>
  </div>
  <p>
    We may disclose your personal information if we are required by law to do so
    or if you violate our Term of Service.
  </p>
  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 4 – Payment </b>
  </div>
  <p>
    We use Razorpay for processing payments. We/Razorpay do not store your card
    data on their servers. The data is encrypted through the Payment Card
    Industry Data Security Standard (PCI-DSS) when processing payment.
  </p>
  <p>
    Your purchase transaction data is only used as long as is necessary to
    complete your purchase transaction. After that is complete, your purchase
    transaction information is not saved. Our payment gateway adheres to the
    standards set by PCI-DSS as managed by the PCI Security Standards Council,
    which is a joint effort of brands like Visa, MasterCard, American Express
    and Discover.
  </p>
  <p>
    PCI-DSS requirements help ensure the secure handling of credit card
    information by our store and its service providers. For more insight, you
    may also want to read terms and conditions of razorpay on
    https://razorpay.com
  </p>

  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 5 - THIRD-PARTY SERVICES</b>
  </div>
  <p>
    In general we do not use any third party providers who tend to save your
    information with personal or medical information.
  </p>
  <p>
    However, certain third-party service providers, such as payment gateways and
    other payment transaction processors, have their own privacy policies in
    respect to the information we are required to provide to them for your
    purchase-related transactions.
  </p>
  <p>
    For these providers, we recommend that you read their privacy policies so
    you can understand the manner in which these providers will handle your
    personal information.
  </p>
  <p>
    In particular, remember that certain providers may be located in or have
    facilities that are located a different jurisdiction than either you or us.
    So if you elect to proceed with a transaction that involves the services of
    a third-party service provider, then your information may become subject to
    the laws of the jurisdiction(s) in which that service provider or its
    facilities are located.
  </p>
  <p>
    Once you leave our store’s app or are redirected to a third-party website or
    application, you are no longer governed by this Privacy Policy or our
    website’s Terms of Service.
  </p>
  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 6 - SECURITY </b>
  </div>
  <p>
    To protect your personal information, we take reasonable precautions and
    follow industry best practices to make sure it is not inappropriately lost,
    misused, accessed, disclosed, altered or destroyed.
  </p>
  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b> SECTION 7 – COOKIES </b>
  </div>
  <p>
    We use cookies to maintain session of your user. It is not used to
    personally identify you on other websites.
  </p>
  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 8 - AGE OF CONSENT </b>
  </div>
  <p>
    By using this app, you represent that you are at least the age of majority
    in your state or province of residence, or that you are the age of majority
    in your state or province of residence and you have given us your consent to
    allow any of your minor dependents to use this app.
  </p>
  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>SECTION 9 - CHANGES TO THIS PRIVACY POLICY </b>
  </div>
  <p>
    We reserve the right to modify this privacy policy at any time, so please
    review it frequently. Changes and clarifications will take effect
    immediately upon their posting on the website. If we make material changes
    to this policy, we will notify you here that it has been updated, so that
    you are aware of what information we collect, how we use it, and under what
    circumstances, if any, we use and/or disclose it.
  </p>
  <p>
    If our store is acquired or merged with another company, your information
    may be transferred to the new owners so that we may continue to sell
    products to you.
  </p>
  <div style="padding:10px;background: #efefef;margin-top: 15px">
    <b>QUESTIONS AND CONTACT INFORMATION </b>
  </div>
  <p>
    If you would like to: access, correct, amend or delete any personal
    information we have about you, register a complaint, or simply want more
    information contact our privacy Compliance officer at query@mavinglubus.com
    or by mail at City center market, Haridwar Road opposite Nulife clinic,
    Najibabad, Pin-246763(UP).
  </p>
  <p>[Re: Privacy Compliance Officer]</p>

  <p>
    [City center market, Haridwar Road opposite Nulife clinic, Najibabad,
    Pin-246763(UP)]
  </p>
</div>
